import { cx } from '@emotion/css';
import React, {
  ReactElement,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';

import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';
import {
  carouselClassName,
  innerClassName,
  itemClassName,
  rowClassName,
} from './styles';

interface Props {
  className?: string;
  children: ReactElement | ReactElement[];
}

export default function Carousel({ className = '', children }: Props) {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [isLoaded, setLoaded] = useState(false);
  const parentRef = useRef(null);
  const presentationRef = useRef(null);

  useEffect(() => setLoaded(true), [parentRef, presentationRef]);

  return (
    <div className={cx(carouselClassName, { [className]: !!className })}>
      {isLoaded && (
        <ArrowLeft
          parentRef={parentRef}
          presentationRef={presentationRef}
          children={children}
        />
      )}
      <div
        className={innerClassName}
        ref={parentRef}
        onScroll={forceUpdate}
        id="carousel"
      >
        <div className={rowClassName} ref={presentationRef}>
          {React.Children.map(children, (child) => (
            <div className={itemClassName}>{React.cloneElement(child)}</div>
          ))}
        </div>
      </div>
      {isLoaded && (
        <ArrowRight
          parentRef={parentRef}
          presentationRef={presentationRef}
          children={children}
        />
      )}
    </div>
  );
}
